export const EmailPattern = /^([^\s@]+@[^\s@]+\.[^\s@]+)?$/
